import { fromZonedTime } from "date-fns-tz"

const TIMEZONE_PADRAO = "America/Sao_Paulo"

export const isInscricaoEncerrada = (dataLimite: string | null | undefined): boolean => {
	if (!dataLimite) return false

	const dataLimiteStr = dataLimite.slice(0, 10)
	const fimDoDia = fromZonedTime(`${dataLimiteStr}T23:59:59.999`, TIMEZONE_PADRAO)

	return new Date() > fimDoDia
}
